import { Box } from '@material-ui/core'

export default function CellData({ children }: { children: React.ReactNode }) {
  return (
    <Box
      overflow="hidden"
      whiteSpace="nowrap"
      textOverflow="ellipsis"
    >
      {children ?? '—'}
    </Box>
  )
}
